module.exports = __webpack_public_path__ + "static/banner-ifood-bg-6c8797d093e1e746b6b4f9a11a09e29f.jpg";